import {
  BE_CALL_ALERTING,
  BE_CALL_ANSWERED,
  BE_HOLD_CALL,
  BE_END_CALL,
  BE_RETRIEVE_CALL,
  FE_RINGING,
  FE_ANSWERED,
  FE_ON_HOLD,
  FE_RELEASED,
} from '@rsos/constants/callStatuses';

/**
 * Get call status display name based on call status value from backend.
 */
const getCallStatusName = (status?: string) => {
  switch (status) {
    case BE_CALL_ALERTING:
      return FE_RINGING;
    case BE_CALL_ANSWERED:
      return FE_ANSWERED;
    case BE_HOLD_CALL:
      return FE_ON_HOLD;
    case BE_END_CALL:
      return FE_RELEASED;
    case BE_RETRIEVE_CALL:
      return FE_ANSWERED;
    default:
      return null;
  }
};

export default getCallStatusName;
